/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react'
import { Button, Divider, TextInput, Tooltip } from '@sede-enterprise/shell-ds-react-framework';
import { Filter, Search } from '@sede-enterprise/shell-ds-react-framework/build/esm/components/Icon/components';
import AnalysisDataList from './components/AnalysisDataList';
import './AnalysisContainer.css';
import useDebounce from '../../util/useDebounce';
import FilterModal from '../../components/FilterModal/FilterModal';
import AnalysisSelection from './components/AnalysisSelection';
import AnalysisChart from './components/AnalysisChart';
import { DocumentTitle } from '../../components/DocumentTitle/DocumentTitle';
import useLogReport from '../../util/hooks/useLogReport';

const sensor_filter = `sensor.excludeFromUi = 0`;
const INIT_SUBJECTS = [
    {
        index: 0,
        type: "",
        name: "",
        site: "",
        shortname: "",
    }
];

const INIT_PAGE = 1;

const AnalysisContainer = () => {


    const [featureOptions, setFeatureOptions] = useState([]);
    const setFeatureOptionsEverywhere = (featureOptionsEverywhere) => {
        setFeatureOptions(featureOptionsEverywhere);
    }

    const [subjects, setSubjects] = useState(INIT_SUBJECTS)
    const setSubjectsEverywhere = (subjectsEverywhere) => {
        setSubjects(subjectsEverywhere);
    }

    const [subjectIndex, setSubjectIndex] = useState(1);
    const setSubjectIndexEverywhere = (subjectIndexEverywhere) => {
        setSubjectIndex(subjectIndexEverywhere);
    }

    const [passedSubjects, setPassedSubjects] = useState([]);
    const setPassedSubjectsEverywhere = (passedSubjectsEverywhere) => {
        setPassedSubjects(passedSubjectsEverywhere);
    }

    const [passedFeature, setPassedFeature] = useState([]);
    const setPassedFeatureEverywhere = (passedFeatureEverywhere) => {
        setPassedFeature(passedFeatureEverywhere);
    }


    const [currentPage, setCurrentPage] = useState(+sessionStorage.getItem("analysisPage") || INIT_PAGE);
    const handleCurrentPageChange = (current) => {
        sessionStorage.setItem('analysisPage', current)
        setCurrentPage(current);
    }
    // Settting the filter for the analysis data
    const [analysisFilter, setAnalysisFilter] = useState(sessionStorage.getItem("analysisApplyfilter") || `sensor.excludeFromUi = 0`);

    const [prevFilter, setPrevFilter] = useState(analysisFilter);

    // Filter Modal
    const [open, setOpen] = useState(false);
    const handleFilterModalClose = () => {
        setOpen(false);
    }

    // Handling the sensor filter change
    const handleSensorFilterChange = (appliedFilter, filterFormValues) => {
        if (appliedFilter) {
            sessionStorage.setItem('analysisApplyfilter', appliedFilter);
            sessionStorage.setItem('analysisFilterValues', JSON.stringify(filterFormValues));
        } else {
            sessionStorage.removeItem('analysisApplyfilter');
            sessionStorage.removeItem('analysisFilterValues');
        }
        setAnalysisFilter(appliedFilter);
    }

    //Clearing the sensor filter
    const clearSensorFilter = () => {
        sessionStorage.removeItem('analysisApplyfilter');
        sessionStorage.removeItem('analysisFilterValues');
        setAnalysisFilter(`sensor.excludeFromUi= 0`);
    }

    useEffect(() => {
        if (prevFilter !== analysisFilter) {
            setCurrentPage(INIT_PAGE);
            sessionStorage.removeItem('analysisPage');
        }
        setPrevFilter(analysisFilter);
    }, [analysisFilter]);

    // Search functionality
    const [searchVal, setSearchVal] = useState("");
    const debouncedSearchVal = useDebounce(searchVal, 500);

    useEffect(() => {
        if (debouncedSearchVal) {
            const filtered_Data = sessionStorage.getItem("analysisApplyfilter");
            const filterValue = filtered_Data
                ? `${filtered_Data} && (contains(upperCase(name), upperCase('${debouncedSearchVal}')) || contains(upperCase(cmLocation), upperCase('${debouncedSearchVal}'))) && ${sensor_filter}`
                : `(contains(upperCase(name), upperCase('${debouncedSearchVal}')) || contains(upperCase(cmLocation), upperCase('${debouncedSearchVal}'))) && ${sensor_filter}`;
            setAnalysisFilter(filterValue);
            setCurrentPage(INIT_PAGE); // Reset the current page
            sessionStorage.removeItem('sensorPage'); // Remove the current page from local storage
        }
        else {
            setAnalysisFilter(sessionStorage.getItem("analysisApplyfilter") || `sensor.excludeFromUi = 0`);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [debouncedSearchVal]);


    // Log Report
    useLogReport('ANALYSIS');

    return (
        <>
            <DocumentTitle title='CARMA - Analysis' />
            <div className='parent-container' id='analysis-container-id-1'>
                <div className='content-container' id='analysis-container-id-2'>
                    <div className='content-header' id='analysis-container-id-3'>
                        <h2 id='analysis-container-id-4'>Feature Analysis</h2>
                        <div className='header-actions' id='analysis-container-id-5'>
                            <div className='search-wrapper' id='analysis-container-id-6'>
                                <TextInput
                                    prefix={{ node: <Search /> }}
                                    placeholder='Search by Sensor or CML name'
                                    onChange={(e) => {
                                        setSearchVal(e.target.value);
                                    }}
                                    value={searchVal}
                                    id='analysis-container-id-7'
                                />
                            </div>

                            <div className='reset-wrapper'>
                                <Button onClick={() => {
                                    setSubjects(INIT_SUBJECTS);
                                    setSubjectIndex(1);
                                    setPassedSubjects([]);
                                    setPassedFeature([]);

                                }}
                                    id='analysis-container-id-16'
                                >Reset</Button>
                            </div>

                            <Tooltip overlay={<span>Filter Options</span>}
                                placement='bottom'
                                trigger={<Button data-testid="filter-btn" iconOnly icon={<Filter id='analysis-container-id-8' />}
                                    onClick={() => setOpen(true)} />}
                                id='analysis-container-id-9' />
                        </div>

                    </div>
                    <div className='content-body' id='analysis-container-id-10'>
                        <AnalysisDataList filter={analysisFilter} INIT_PAGE={INIT_PAGE} currentPage={currentPage} handleCurrentPageChange={handleCurrentPageChange} subjects={subjects} subjectIndex={subjectIndex}
                            updateSubjects={setSubjectsEverywhere} updateSubjectsIndex={setSubjectIndexEverywhere}
                            setFeatureOptionsEverywhere={setFeatureOptionsEverywhere}
                            id='analysis-container-id-11' />
                    </div>
                </div>
                <FilterModal open={open} onClose={handleFilterModalClose}
                    handleFilterChange={handleSensorFilterChange}
                    handleFilterClear={clearSensorFilter}
                    filterKey='analysisFilterValues'
                    id='analysis-container-id-12'
                />
            </div>
            <br />
            <Divider id='analysis-container-id-13' />
            <AnalysisSelection selectedSubjects={subjects}
                passedFeature={passedFeature}
                setPassedFeatureEverywhere={setPassedFeatureEverywhere}
                setPassedSubjectsEverywhere={setPassedSubjectsEverywhere}
                featureOptions={featureOptions}
                id='analysis-container-id-14' />

            <br />
            {(passedSubjects.length > 0 || passedSubjects[0]?.index > 0) && passedFeature.length > 0 && subjects.length > 1 ? <AnalysisChart passedSubjects={passedSubjects} passedFeature={passedFeature} id='analysis-container-id-15' /> :
                <div className='spacer'>
                    <br />
                    <br />
                    <br />
                    <br />
                    <br />
                    <br />
                </div>
            }

        </>
    )
}

export default AnalysisContainer